import { useEffect, useState } from 'react';
import Modal from '@components/modal/Modal';
import Button from '@components/button/Button';
import { IconIdle } from '@src/constants';
import { LordIcon } from '@src/components/lord-icon/lord-icon';
import styles from './UserInactivityModal.module.scss';
import { logger } from '../../../utils/logger';

type Props = {
  open: boolean;
  onOkAction: () => void;
  onCancelAction: () => void;
};

function UserInactivityModal(props: Props) {
  const { open, onOkAction, onCancelAction } = props;
  const [countdown, setCountdown] = useState(30);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (open) {
      logger.warn('[InactivityModal] Modal opened, starting countdown');
      setCountdown(30);
      timer = setInterval(() => {
        setCountdown(prev => {
          // Log the countdown at specific intervals
          if (prev % 5 === 0 || prev <= 5) {
            logger.warn(`[InactivityModal] Countdown: ${prev} seconds remaining`);
          }
          
          if (prev <= 1) {
            logger.warn('[InactivityModal] Countdown finished, logging out user');
            clearInterval(timer);
            onCancelAction(); // Auto logout when countdown reaches 0
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => {
      if (timer) {
        logger.warn('[InactivityModal] Clearing timer');
        clearInterval(timer);
      }
    };
  }, [open, onCancelAction]);

  return (
    <Modal 
      open={!!open} 
      closeButton={false} 
      className={styles.wrapper}
      closeOnOverlayClick={false}
    >
      <div className={styles.mainView} onClick={(e) => e.stopPropagation()}>
        <div className={styles.iconWrapper}>
          <LordIcon
            src={IconIdle}
            disabled={false}
            size={120}
            target=".UserInactivityModal_mainView__0NkHB"
          />
        </div>
        <div className={styles.title}>Are you still there?</div>
        <div className={styles.detail}>
          You appear to be inactive. Click 'Stay Logged In' to continue your session, or you will be automatically logged out in {countdown} seconds.
        </div>
          <div className={styles.content}>
            <div className={styles.action}>
              <Button size='small' className={styles.actionButton} onClick={onOkAction} label="Stay Logged In" />
              <Button size='small' className={styles.cancelButton} onClick={onCancelAction} label="Logout" />
            </div>
          </div>
      </div>
    </Modal>
  );
}

export default UserInactivityModal;
